import { render, staticRenderFns } from "./Offre.vue?vue&type=template&id=50dc30c2&"
import script from "./Offre.vue?vue&type=script&lang=js&"
export * from "./Offre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports